<template>
  <div :class="`custom-checkbox-dealer-${theme}`" @click="$emit('update:modelValue', isChecked)">
    <input
      :id="inputId"
      v-model="isChecked"
      type="checkbox"
      :name="inputId"
      :required="required"
      @change="$emit('update:modelValue', isChecked)"
    />
    <label :for="inputId" class="font-weight-normal fs-4">
      {{ label }}
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    validate: Boolean,
    label: String,
    required: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    theme: {
      type: String,
      default: 'primary'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isChecked = ref(props.modelValue)
    const inputId = `checkbox-${Math.random().toString(36).substr(2, 9)}`

    return {
      isChecked,
      inputId
    }
  }
})
</script>

<style lang="scss">
@use '~concierge/styles/variables' as *;

$CLASS_PREFIX: 'custom-checkbox';
$border-style: 1px solid #ced4da;

[class*='#{$CLASS_PREFIX}-'] {
  min-height: 22px;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  padding-left: 0;

  > label {
    padding-left: 29px !important;
    min-height: 22px;
    line-height: 22px;
    display: inline-block;
    position: relative;
    vertical-align: top;
    margin-bottom: 0;
    font-weight: inherit;
    font-size: inherit;
    cursor: pointer;
  }

  > input[type='checkbox'] {
    position: absolute !important;
    opacity: 0;
    margin: 0;

    &:disabled {
      cursor: default;
    }

    + input[type='hidden'] + label::before,
    + label::before {
      content: '';
      display: inline-block;
      position: absolute;
      width: 22px;
      height: 22px;
      margin-left: -29px;
      border-radius: 0.25rem;
      border: $border-style;
    }

    &:checked + input[type='hidden'] + label::after,
    &:checked + label::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 7px;
      height: 10px;
      border: 2px solid #fff;
      border-left: none;
      border-top: none;
      transform: translate(7.75px, 4.5px) rotate(45deg);
    }

    &:not(:checked):not(:disabled):hover + input[type='hidden'] + label::before,
    &:not(:checked):not(:disabled):hover + label::before {
      border-width: 2px;
    }

    &:disabled + input[type='hidden'] + label,
    &:disabled + input[type='hidden'] + label::before,
    &:disabled + label,
    &:disabled + label::before {
      pointer-events: none;
      cursor: default;
      filter: alpha(opacity=65);
      box-shadow: none;
      opacity: 0.65;
    }
  }
}

@each $theme, $color in $alfredThemes {
  .#{$CLASS_PREFIX}-#{$theme}
    > input[type='checkbox']:not(:checked):not(:disabled):hover
    + input[type='hidden']
    + label::before,
  .#{$CLASS_PREFIX}-#{$theme}
    > input[type='checkbox']:not(:checked):not(:disabled):hover
    + label::before {
    border-color: $color;
  }

  .#{$CLASS_PREFIX}-#{$theme}
    > input[type='checkbox']:checked
    + input[type='hidden']
    + label::before,
  .#{$CLASS_PREFIX}-#{$theme} > input[type='checkbox']:checked + label::before {
    background-color: $color;
    border-color: $color;
  }
}
</style>
